import ApiUtils from '@/api/util/ApiUtils';
import SponsorModel from '@/api/model/SponsorModel';
import ITier from '@/api/interface/ITier';

export default class SponsorDTO {

  public static fromModel(objs: SponsorModel[]): ITier[]  {
    if (objs === null) {
      return [];
    }
    const data: ITier[] = [];
    for (const obj of objs) {
      data.push({ name: obj.name, sponsors: obj.sponsors});
    }
    return data;
  }


}
